export interface AuthentifiedUser {
  userId: string;
  sk: string;
  firstName: string;
  lastName: string;
  email: string;
  guest: boolean;
  organizationIds: string[];
  currentOrganizationId: string;
  permissions: string[];
  role: Role;
}

export enum Role {
  Admin = 'admin',
  User = 'user',
  Guest = 'guest',
  ContentManager = 'contentManager',
}

export interface SimpleUser {
  userId: string;
  email: string;
  role: Role;
  organisationId: string;
  username?: string;
}

export function getUserName(firstName?: string, lastName?: string): string {
  return `${firstName || ''} ${lastName || ''}`.trim();
}
